/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'

import BackButton from '../../components/BackButton/BackButton';
import styles from './ReportNoManagerPage.module.css';
import  ReportForm  from '../../components/ReportNoManager/ReportNoManager';
import  UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';

import { CustomTab } from '../../atomicComponents';

function ReportNoManagerPage({product}) {
  const history = useHistory();
  const redirectToProcessPage = () => {
    history.push('/home');
  };


  return (
    <>
      <div className={styles.container} style={{ boxSizing: 'border-box' }}>
          <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToProcessPage}
          />
        </div>
        <div className={styles.processHeader}>
        <div className={styles.CustomTabClass} >
            <CustomTab title="Report" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
         
                <UserInfoPanel 
                userInfo={[{"Name":"Pratik Tarade",
                "SAP ID":122355,"BC No":"122355",
                "LOC":"Engineering and Research Center"
                }]} />

              </div>

        </div>
     
        <ReportForm redirectToProcessPage={redirectToProcessPage}/>

      </div>
    </>
  )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
ReportNoManagerPage.propTypes = {

  product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(ReportNoManagerPage); 
